<script>
import countries from "i18n-iso-countries";
import deLocale from "i18n-iso-countries/langs/de.json";

export default {
    props: {
        fetched: {},
        create: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            Reference: [],
            translations: {},
            translationTab: 'de_AT',
            translationList: '',
            selectedCountry: '',
        }
    },

    mounted() {
        if (this.$root.Storage.get('settings') && typeof this.$root.Storage.get('settings').locale !== 'undefined') {
            this.translationTab = this.$root.Storage.get('settings').locale
        }

        if (typeof this.fetched !== 'undefined' && 'ReferenceI18ns' in this.fetched) {
            let translationList = []

            this.fetched.ReferenceI18ns.forEach(translation => {
                translationList.push(translation.Locale)
                this.translations[translation.Locale] = {
                    Name: translation.Name,
                    DescriptionShort: translation.DescriptionShort,
                    Description: translation.Description,
                }
            })

            this.$root.dataLanguages.forEach(language => {
                if (typeof this.translations[language.LocaleCode] === 'undefined') {
                    translationList.push(language.LocaleCode)
                    this.translations[language.LocaleCode] = {
                        Name: '',
                        DescriptionShort: '',
                        Description: '',
                    }
                }
            })

            translationList.sort()
            this.translationList = translationList.join('|')
        }
    },

    computed: {
        countryList() {
            countries.registerLocale(deLocale);

            return Object.entries(countries.getNames('de', {select: 'official'}))
                .map(([value, label]) => ({value, label}))
                .sort((a, b) => a.label.localeCompare(b.label));
        },
    },

    methods: {
        beforeSend(content, call) {
            if (this.translationList.length > 4) {
                content['ReferenceI18ns'] = []
                this.translationList.split('|').forEach(localeCode => {
                    if (localeCode.includes('::')) {
                        return
                    }
                    let translation = JSON.parse(JSON.stringify(this.translations[localeCode]))
                    if (translation.Name) {
                        translation.Id = this.fetched.Id
                        translation.Locale = localeCode
                        content['ReferenceI18ns'].push(translation)
                    }
                })
                // delete all translations with "--" in key
                for (const key in content) {
                    if (key.includes('--')) {
                        delete content[key]
                    }
                }
            }

            return [content, this.$root.stringPlaceholders(call, content)]
        },
        copyTranslationValue(name, value) {
            if (confirm(this.$t('Do you want to copy the value of this field to all other languages in this folder?'))) {
                for (const language in this.translations) {
                    if (typeof this.translations[language][name] !== 'undefined') {
                        this.translations[language][name] = value
                    }
                }
            }
        },
    },
}
</script>

<template>
    <div>
        <bg-form v-if="create" :button="$t('Create reference')" :beforeSend="'beforeSend'" call="reference"
                 @afterSend="$emit('afterSend')">
            <bg-form-input :label="$t('ID')" :size="3" :prefill="$t('Will be created automatically')"/>
            <bg-form-input :label="$t('Title')" name="Name" :size="3" localize="Reference"/>
            <bg-form-input :label="$t('Opportunity number')" name="OpportunityNumber" :size="3"/>
            <bg-form-search-select :label="$t('Country')" name="CountryIso" :size="3" :options="countryList"/>
            <bg-form-input :label="$t('Teaser')" name="DescriptionShort" :size="12" localize="Reference"/>
            <bg-form-input :label="$t('Description')" :textarea="true" name="Description" :size="12" localize="Reference"/>
        </bg-form>

        <bg-form v-if="!create" :button="$t('Save changes')" :beforeSend="'beforeSend'" call="reference/${__ID}"
                 @afterSend="$emit('afterSend')">
            <bg-form-input :label="$t('ID')" :prefill="fetched.Id" :size="1"/>
            <bg-form-input :label="$t('Opportunity number')" :prefill="fetched.OpportunityNumber" name="OpportunityNumber" :size="3"/>
            <bg-form-search-select :label="$t('Country')" name="CountryIso" :prefill="fetched.CountryIso" :size="3" :options="countryList"/>

            <div class="field is-12 column">
                <div class="b-tabs">
                    <nav class="tabs is-boxed" style="margin: 1rem -1rem 0">
                        <ul style="padding: 0 1.25rem">
                            <template v-for="(translation, key) in translationList.split('|')">
                                <li v-if="!translation.includes('::')"
                                    :class="{'is-active': translationTab === translation}" :key="key">
                                    <a @click.prevent="translationTab = translation"
                                       style="padding-left: 0.5rem; padding-right: 0.5rem">
                                        <span>{{ translation.replace('_', '/') }}</span>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </nav>

                    <template v-for="(translation, key) in translationList.split('|')">
                        <section :key="key" v-if="translationTab === translation">
                            <div class="tab-item columns"
                                 style="padding-top: 1rem; padding-bottom: 1rem; flex-wrap: wrap">
                                <bg-form-input
                                    :label="$t('Title')"
                                    :name="'Name--' + translation"
                                    :prefill="translations[translation].Name"
                                    @sync="value => translations[translation]['Name'] = value"
                                    :size="6">
                                    <button class="button is-input-copy"
                                            @click.prevent="copyTranslationValue('Name', translations[translation]['Name'])">
                                        <b-icon icon="content-copy" custom-size="default"></b-icon>
                                    </button>
                                </bg-form-input>
                                <bg-form-input
                                    :label="$t('Teaser')"
                                    :name="'DescriptionShort--' + translation"
                                    :prefill="translations[translation].DescriptionShort"
                                    @sync="value => translations[translation]['DescriptionShort'] = value"
                                    :size="6">
                                    <button class="button is-input-copy"
                                            @click.prevent="copyTranslationValue('DescriptionShort', translations[translation]['DescriptionShort'])">
                                        <b-icon icon="content-copy" custom-size="default"></b-icon>
                                    </button>
                                </bg-form-input>
                                <bg-form-wysiwyg
                                    :label="$t('Description')"
                                    :name="'Description--' + translation"
                                    :prefill="translations[translation].Description"
                                    @sync="value => translations[translation]['Description'] = value"
                                    :size="12">
                                    <button class="button is-input-copy"
                                            @click.prevent="copyTranslationValue('Description', translations[translation]['Description'])">
                                        <b-icon icon="content-copy" custom-size="default"></b-icon>
                                    </button>
                                </bg-form-wysiwyg>
                            </div>
                        </section>
                    </template>
                </div>
            </div>
        </bg-form>
    </div>
</template>
